(function () {
  var drawer = document.querySelector('[data-site-drawer]');
  var backdrop = document.querySelector('[data-menu-close]');
  var openButton = document.querySelector('[data-menu-open]');
  if (!drawer || !openButton) return;

  var closeButtons = document.querySelectorAll('[data-menu-close]');

  function setOpen(open) {
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    openButton.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (backdrop) backdrop.hidden = !open;
    document.documentElement.classList.toggle('drawer-open', open);
  }

  openButton.addEventListener('click', function () {
    setOpen(true);
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      setOpen(false);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') setOpen(false);
  });
})();


/* ==========================================================================
   商品图片放大查看（lightbox）
   2026-10-08
   独立 IIFE：上面的抽屉脚本在没有抽屉的页面会 return，不能写在同一个里。
   ========================================================================== */
(function () {
  'use strict';

  // 每组的容器 + 图片选择器；组内图片可以左右切换
  var GROUPS = [
    { root: '.product-gallery', sel: 'img' },
    { root: '.product-description', sel: 'img' }
  ];
  // 排除描述里的细条 logo / 分隔图：按"原图高度"判断比按宽度准
  // （品牌 logo 是 748x160 的细条，按宽度拦不住；按高度 160 < 200 能拦住）
  var MIN_NATURAL_HEIGHT = 200;

  function pickable(img) {
    var h = img.naturalHeight || 0;
    if (h && h < MIN_NATURAL_HEIGHT) return false;
    return true;
  }

  function listFor(img) {
    for (var i = 0; i < GROUPS.length; i++) {
      var root = img.closest(GROUPS[i].root);
      if (!root) continue;
      var all = Array.prototype.slice.call(root.querySelectorAll(GROUPS[i].sel))
        .filter(pickable);
      if (all.indexOf(img) !== -1) return all;
    }
    return [img];
  }

  // 取大图地址：优先用模板给的 data-zoom-src，否则把 CDN 的 width 参数抬高
  function bigSrc(img) {
    var z = img.getAttribute('data-zoom-src');
    if (z) return z;
    var s = img.currentSrc || img.src || '';
    if (/[?&]width=\d+/.test(s)) return s.replace(/([?&])width=\d+/, '$1width=2048');
    return s;
  }

  var overlay, imgEl, counterEl, prevBtn, nextBtn, closeBtn;
  var items = [];
  var index = 0;
  var lastFocus = null;
  var built = false;
  var touchX = null;

  function build() {
    if (built) return;
    built = true;

    overlay = document.createElement('div');
    overlay.className = 'product-lightbox';
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    overlay.setAttribute('aria-label', 'Product image viewer');
    overlay.innerHTML =
      '<div class="product-lightbox__stage">' +
        '<img class="product-lightbox__img" alt="">' +
      '</div>' +
      '<button class="product-lightbox__close" type="button" aria-label="Close">&times;</button>' +
      '<button class="product-lightbox__nav product-lightbox__nav--prev" type="button" aria-label="Previous image">&#8249;</button>' +
      '<button class="product-lightbox__nav product-lightbox__nav--next" type="button" aria-label="Next image">&#8250;</button>' +
      '<div class="product-lightbox__counter" aria-live="polite"></div>';

    document.body.appendChild(overlay);

    imgEl = overlay.querySelector('.product-lightbox__img');
    counterEl = overlay.querySelector('.product-lightbox__counter');
    prevBtn = overlay.querySelector('.product-lightbox__nav--prev');
    nextBtn = overlay.querySelector('.product-lightbox__nav--next');
    closeBtn = overlay.querySelector('.product-lightbox__close');

    closeBtn.addEventListener('click', close);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });

    // 点遮罩/空白处关闭（点图片本身不关）
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay || e.target.classList.contains('product-lightbox__stage')) {
        close();
      }
    });

    // 移动端左右滑动切换
    overlay.addEventListener('touchstart', function (e) {
      touchX = e.touches[0].clientX;
    }, { passive: true });
    overlay.addEventListener('touchend', function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  function render() {
    var current = items[index];
    if (!current) return;
    imgEl.setAttribute('src', bigSrc(current));
    imgEl.setAttribute('alt', current.getAttribute('alt') || '');

    var many = items.length > 1;
    prevBtn.style.display = many ? '' : 'none';
    nextBtn.style.display = many ? '' : 'none';
    counterEl.textContent = many ? (index + 1) + ' / ' + items.length : '';

    // 预载前后各一张，切换更顺
    [index - 1, index + 1].forEach(function (k) {
      if (k >= 0 && k < items.length) {
        var pre = new Image();
        pre.src = bigSrc(items[k]);
      }
    });
  }

  function open(list, i) {
    build();
    items = list;
    index = i;
    lastFocus = document.activeElement;

    var sbw = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.setProperty('--plb-sbw', (sbw > 0 ? sbw : 0) + 'px');

    render();
    overlay.classList.add('is-open');
    document.body.classList.add('product-lightbox-open');
    closeBtn.focus();
  }

  function close() {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    overlay.classList.remove('is-open');
    document.body.classList.remove('product-lightbox-open');
    document.body.style.removeProperty('--plb-sbw');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function go(step) {
    if (items.length < 2) return;
    index = (index + step + items.length) % items.length;
    render();
  }

  document.addEventListener('keydown', function (e) {
    if (!overlay || !overlay.classList.contains('is-open')) return;
    if (e.key === 'Escape') { close(); }
    else if (e.key === 'ArrowLeft') { go(-1); }
    else if (e.key === 'ArrowRight') { go(1); }
  });

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var img = t.closest('.product-gallery__image img, .product-description img');
    if (!img || !pickable(img)) return;
    var list = listFor(img);
    if (!list.length) return;
    e.preventDefault();
    open(list, Math.max(0, list.indexOf(img)));
  });
})();
